import {Tooltip} from '@material-ui/core';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

const UserButtons = ({setOpenReturnDialog}) => {
  const {t} = useTranslation();
  const checkListIcon = {
    title: t('common:orders'),
    link: '/profile/orders',
    icon: (
      <svg
        className="svg-stroke"
        width="15"
        height="17"
        viewBox="0 0 15 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.4207 2.5H11.9207C12.3185 2.5 12.7 2.65804 12.9813 2.93934C13.2626 3.22064 13.4207 3.60218 13.4207 4V14.5C13.4207 14.8978 13.2626 15.2794 12.9813 15.5607C12.7 15.842 12.3185 16 11.9207 16H2.92065C2.52283 16 2.1413 15.842 1.85999 15.5607C1.57869 15.2794 1.42065 14.8978 1.42065 14.5V4C1.42065 3.60218 1.57869 3.22064 1.85999 2.93934C2.1413 2.65804 2.52283 2.5 2.92065 2.5H4.42065"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.70636 10.1667L6.37303 11.8333L9.70636 8.5"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.67065 1H5.17065C4.97174 1 4.78098 1.07902 4.64032 1.21967C4.49967 1.36032 4.42065 1.55109 4.42065 1.75V3.25C4.42065 3.44891 4.49967 3.63968 4.64032 3.78033C4.78098 3.92098 4.97174 4 5.17065 4H9.67065C9.86957 4 10.0603 3.92098 10.201 3.78033C10.3416 3.63968 10.4207 3.44891 10.4207 3.25V1.75C10.4207 1.55109 10.3416 1.36032 10.201 1.21967C10.0603 1.07902 9.86957 1 9.67065 1V1Z"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  };
  const walletIcon = {
    title: t('common:finance'),
    link: '/profile/finance/',
    icon: (
      <svg
        className="svg-stroke"
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.4207 8.5V4.75H3.17065C2.70653 4.75 2.26141 4.55246 1.93322 4.20083C1.60503 3.84919 1.42065 3.37228 1.42065 2.875C1.42065 1.84375 2.20815 1 3.17065 1H13.6707V4.75"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.42065 2.875V14.125C1.42065 15.1563 2.20815 16 3.17065 16H15.4207V12.25"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6707 8.5C13.2065 8.5 12.7614 8.69754 12.4332 9.04918C12.105 9.40081 11.9207 9.87772 11.9207 10.375C11.9207 11.4063 12.7082 12.25 13.6707 12.25H17.1707V8.5H13.6707Z"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  };

  const listIcon = {
    title: t('common:invoice'),
    link: '/profile/invoice/',
    icon: (
      <svg
        className="svg-stroke"
        width="14"
        height="17"
        viewBox="0 0 14 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.04565 1H2.67065C2.27283 1 1.8913 1.15804 1.60999 1.43934C1.32869 1.72064 1.17065 2.10218 1.17065 2.5V14.5C1.17065 14.8978 1.32869 15.2794 1.60999 15.5607C1.8913 15.842 2.27283 16 2.67065 16H11.6707C12.0685 16 12.45 15.842 12.7313 15.5607C13.0126 15.2794 13.1707 14.8978 13.1707 14.5V5.125L9.04565 1Z"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.67065 1V5.5H13.1707"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1707 9.25H4.17065"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1707 12.25H4.17065"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.67065 6.25H4.17065"
          stroke="white"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  };

  const timerIcon = {
    title: t('common:reconciliation'),
    link: '/profile/reconciliation',
    icon: (
      <svg
        className="svg-fill"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.8438 13.2422C14.6531 13.2422 13.6875 14.2078 13.6875 15.3984C13.6875 16.5891 14.6531 17.5547 15.8438 17.5547C17.0344 17.5547 18 16.5891 18 15.3984C18 14.2078 17.0344 13.2422 15.8438 13.2422ZM15.8438 16.1953C15.4031 16.1953 15.0469 15.8391 15.0469 15.3984C15.0469 14.9578 15.4031 14.6016 15.8438 14.6016C16.2844 14.6016 16.6406 14.9578 16.6406 15.3984C16.6406 15.8391 16.2844 16.1953 15.8438 16.1953ZM20.625 3.9375H15.6562C15.6562 3.21328 15.068 2.625 14.3438 2.625H12.4688C11.7445 2.625 11.1562 3.21328 11.1562 3.9375H6.1875C5.77266 3.9375 5.4375 4.27266 5.4375 4.6875V9.375H3.375C2.96016 9.375 2.625 9.71016 2.625 10.125V20.625C2.625 21.0398 2.96016 21.375 3.375 21.375H11.25C11.6648 21.375 12 21.0398 12 20.625V20.25H20.625C21.0398 20.25 21.375 19.9148 21.375 19.5V4.6875C21.375 4.27266 21.0398 3.9375 20.625 3.9375ZM10.9688 5.4375H12.6562V4.125H14.1562V5.4375H15.8438V6.5625H10.9688V5.4375ZM10.5 19.875H4.125V14.4375H10.5V19.875ZM10.5 12.9375H4.125V10.875H10.5V12.9375ZM19.6875 18.5625H12V10.125C12 9.71016 11.6648 9.375 11.25 9.375H7.125V5.625H9.46875V8.0625H17.3438V5.625H19.6875V18.5625ZM16.5 9.5625V11.8125C16.5 11.9156 16.5844 12 16.6875 12H17.8125C17.9156 12 18 11.9156 18 11.8125V9.5625C18 9.45937 17.9156 9.375 17.8125 9.375H16.6875C16.5844 9.375 16.5 9.45937 16.5 9.5625ZM13.875 12H15C15.1031 12 15.1875 11.9156 15.1875 11.8125V10.5C15.1875 10.3969 15.1031 10.3125 15 10.3125H13.875C13.7719 10.3125 13.6875 10.3969 13.6875 10.5V11.8125C13.6875 11.9156 13.7719 12 13.875 12Z"
          fill="white"
        />
      </svg>
    ),
  };

  const returnIcon = {
    title: t('common:return_terms'),
    link: '/return_terms',
    // handler: () => setOpenReturnDialog(true),
    icon: (
      <svg
        className="svg-fill svg-stroke"
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 18 18"
        fill="none">
        <path
          d="M7.50285 1.13884C4.46648 1.78184 2.18027 3.93409 1.24257 7.01511C1.01931 7.74741 0.992517 7.94388 1.00145 9.20308C1.00145 10.4444 1.02824 10.6677 1.24257 11.391C2.14455 14.4006 4.35038 16.5261 7.27958 17.1869C10.3695 17.8924 13.5845 16.7851 15.5492 14.3381C16.1476 13.5969 16.737 12.552 16.9334 11.9001C17.0317 11.5429 17.0317 11.4982 16.862 11.3285C16.5048 10.9713 16.3083 11.1499 15.7457 12.3109C15.326 13.195 15.1295 13.4897 14.549 14.1059C13.2452 15.4991 11.8252 16.2224 9.98552 16.4546C8.51199 16.6422 6.76161 16.2671 5.43097 15.4723C3.80562 14.5078 2.48391 12.7038 2.05525 10.8731C1.50155 8.46185 2.17134 5.96131 3.86814 4.17521C6.30616 1.61216 10.2534 1.14778 13.1558 3.07676C13.8346 3.52329 14.5847 4.16628 14.5133 4.2288C14.4865 4.25559 14.1561 4.2288 13.7721 4.17521C12.9862 4.05912 12.7897 4.12163 12.745 4.48778C12.7004 4.85393 12.9594 4.97003 14.2275 5.17543C15.6117 5.38976 15.8886 5.40762 16.0136 5.24687C16.0672 5.18436 16.219 4.49671 16.353 3.71976L16.5852 2.30874L16.3976 2.1212C16.2458 1.96938 16.1744 1.95152 15.969 2.02296C15.7457 2.09441 15.71 2.17478 15.6028 2.72847C15.3885 3.9073 15.4599 3.84478 14.933 3.33575C13.7274 2.16585 12.1824 1.37104 10.5481 1.08526C9.79798 0.951305 8.24408 0.978096 7.50285 1.13884Z"
          fill="white"
          stroke="white"
          stroke-width="0.35"
        />
        <path
          d="M6.97097 5.13995C5.70284 5.75616 4.60439 6.30985 4.54188 6.36343C4.45257 6.43488 4.42578 7.07787 4.42578 9.38194C4.42578 12.0522 4.43471 12.3111 4.58653 12.4362C4.77662 12.609 8.92947 14.6043 9.32825 14.7337C9.34625 14.7395 9.36435 14.7383 9.38202 14.7315C9.56877 14.6599 10.6218 14.1606 11.8381 13.5525L13.983 12.4841C14.1188 12.4164 14.2047 12.2777 14.2047 12.126V9.38194V6.63873C14.2047 6.48655 14.1183 6.34755 13.9819 6.28013L11.9095 5.25605C10.6414 4.63985 9.53402 4.10402 9.44472 4.07723C9.34648 4.0415 8.42664 4.44338 6.97097 5.13995ZM11.1504 5.8276L12.3104 6.39225C12.5253 6.49683 12.5259 6.80278 12.3114 6.90819V6.90819L11.9695 7.07914C11.8585 7.13465 11.728 7.13547 11.6163 7.08136L10.0788 6.33664C9.13215 5.88119 8.3552 5.48824 8.3552 5.45252C8.3552 5.37215 9.0875 5.01493 9.28397 5.01493C9.3822 5.006 10.2217 5.37215 11.1504 5.8276ZM9.12322 6.82782L10.1121 7.31439C10.3936 7.45294 10.3897 7.85569 10.1056 7.98878V7.98878C9.72156 8.16739 9.35541 8.31028 9.2929 8.31028C9.23039 8.31028 8.41771 7.9352 7.48894 7.47081L6.47111 6.9619C6.20386 6.82828 6.20904 6.44513 6.47979 6.31878V6.31878C6.84594 6.1491 7.21209 5.99728 7.29247 5.99728C7.36391 5.98835 8.19445 6.36343 9.12322 6.82782ZM8.15873 8.74787L8.66991 9.00347C8.80543 9.07122 8.89103 9.20973 8.89103 9.36124V11.3466C8.89103 12.5791 8.87317 13.5793 8.84637 13.5793C8.82851 13.5793 8.00691 13.1953 7.01562 12.713L5.45643 11.9646C5.31775 11.898 5.22953 11.7578 5.22953 11.604V9.59627V7.96771C5.22953 7.67437 5.5348 7.48081 5.80013 7.60592L6.32798 7.85482C6.92632 8.1406 7.74792 8.54247 8.15873 8.74787ZM13.4456 9.58734V11.5961C13.4456 11.7494 13.358 11.8892 13.22 11.9561L11.6952 12.6952C10.7307 13.1595 9.9091 13.5435 9.86445 13.5614C9.8198 13.5793 9.78408 12.5969 9.78408 11.3556V9.36124C9.78408 9.20973 9.86968 9.07122 10.0052 9.00347L10.4985 8.7568C10.8915 8.56033 11.2308 8.39958 11.2576 8.39958C11.2844 8.39958 11.3023 8.85504 11.3023 9.41766C11.3023 10.2303 11.3291 10.4715 11.4451 10.5786C11.6059 10.7483 11.6952 10.7572 11.9363 10.6322C12.0881 10.5429 12.106 10.4268 12.106 9.23905V8.19909C12.106 8.04357 12.1961 7.90215 12.3371 7.83649L12.7579 7.64049C12.9614 7.54137 13.1496 7.45444 13.2745 7.39928C13.3716 7.35643 13.4321 7.3958 13.4341 7.50187C13.4405 7.83771 13.4456 8.6487 13.4456 9.58734Z"
          fill="white"
          stroke="white"
          stroke-width="0.3"
        />
      </svg>
    ),
  };

  const userButtonIcons = [
    checkListIcon,
    listIcon,
    walletIcon,
    timerIcon,
    //returnIcon,
  ];

  return userButtonIcons.map(item => (
    <Tooltip key={item.title} title={item.title}>
      {!item.link ? (
        <div className="cursor-pointer" onClick={item.handler}>
          {item.icon}
        </div>
      ) : (
        <Link to={item.link} className="btn btn-transparent btn-icon">
          {item.icon}
        </Link>
      )}
    </Tooltip>
  ));
};

export default UserButtons;
